import { apiPost } from './http-client';
import type { MySubscriptionItem } from './my-subscriptions-list';

/** POST /api/v1/subscriptions/my-subscriptions/{sub_id}/freeze */
export function freezeSubscription(
  subId: number,
  accessToken: string
): Promise<MySubscriptionItem> {
  return apiPost<MySubscriptionItem>(
    `/api/v1/subscriptions/my-subscriptions/${subId}/freeze`,
    {},
    { accessToken }
  );
}

/** POST /api/v1/subscriptions/my-subscriptions/{sub_id}/unfreeze */
export function unfreezeSubscription(
  subId: number,
  accessToken: string
): Promise<MySubscriptionItem> {
  return apiPost<MySubscriptionItem>(
    `/api/v1/subscriptions/my-subscriptions/${subId}/unfreeze`,
    {},
    { accessToken }
  );
}
